import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { IconButton, Tooltip } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";

import { queryClient } from "App";
import { ModalContext } from "contexts/ModalProvider";
import { useAuthentication } from "hooks/useAuthentication";
import { DELIVERY_COST_KEY } from "hooks/useDeliveryCost";
import { API } from "utils/api";
import { isAdmin } from "utils/models/user";

export const DeliveryConfig = () => {
  const { user } = useAuthentication();
  const { setDeliveryConfigModalProps } = useContext(ModalContext);

  const deliveryConfigMutation = useMutation({
    mutationFn: async ({
      cost,
      minAmount,
    }: {
      cost: number;
      minAmount: number;
    }) => API.put("delivery_costs", { cost, min_amount: minAmount }),
    onSuccess: () => queryClient.invalidateQueries(DELIVERY_COST_KEY),
  });

  const onDeliveryConfigClick = useCallback(() => {
    setDeliveryConfigModalProps({
      open: true,
      onSubmit: deliveryConfigMutation.mutateAsync,
    });
  }, [setDeliveryConfigModalProps, deliveryConfigMutation.mutateAsync]);

  if (!user || !isAdmin(user)) return null;

  return (
    <Tooltip title="Configuración de envíos">
      <IconButton size="large" onClick={onDeliveryConfigClick}>
        <LocalShippingIcon titleAccess="Configuración de envíos" />
      </IconButton>
    </Tooltip>
  );
};
